/**
 * API URL Configuration
 * Automatically routes to correct backend based on environment
 */
export const getApiUrl = () => {
  // Server-side rendering check (for Next.js)
  if (typeof window === 'undefined') {
    return process.env.NEXT_PUBLIC_API_URL || 'https://api.genanything.ai';
  }
  
  const hostname = window.location.hostname;
  
  // Production frontend
  if (hostname === 'genanything.ai' || hostname === 'www.genanything.ai') {
    return 'https://api.genanything.ai';
  }
  
  // Development frontend
  if (hostname === 'dev.genanything.ai') {
    return 'https://devapi.genanything.ai';
  }
  
  // Local development - use dev API
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return 'https://devapi.genanything.ai';
  }
  
  // Fallback to production
  console.warn(`Unknown hostname: ${hostname}, defaulting to production`);
  return 'https://api.genanything.ai';
};

export const API_URL = getApiUrl();

// Debug logging (only in development)
if (typeof window !== 'undefined' && process.env.NODE_ENV === 'development') {
  console.log('🔗 API URL:', API_URL);
  console.log('🌐 Hostname:', window.location.hostname);
}
